module.exports = __webpack_public_path__ + "img/not-allowed.4e56390.svg";